export class UserProfile {
  static readonly type = '[PORTAL] Toggle UserProfile';
}

export class ToogleSearchBar {
  static readonly type = '[PORTAL] Toggle searchBar';
}

export class SetItemPosition {
  static readonly type = '[PORTAL] set format item position';
  constructor(public payload: string) {}
}

export class CheckProducerRole {
  static readonly type = '[PORTAL] check for producers role';
  constructor() {}
}
export class SetScrollPosition {
  static readonly type = '[PORTAL] set scroll position';
  constructor(public payload: string) {}
}
